export const TOKENS = {
  maroon: '#861F41',
  maroonDark: '#5C1229',
  orange: '#E5751F',
  orangeDark: '#B75813',
  stone: '#75787B',
  stone2: '#A6A9AC',
  stone3: '#E1E2E3',
  paper: '#FBF8F2',
  paper2: '#F2ECE0',
  ink: '#2C2A29',
  ink70: '#5A5856',
};
